import React from "react";
import { useAuth } from "../auth/AuthProvider";

const FALLBACK_LOGO = "/assets/hbfa-logo.png";

function logoForProject(projectId) {
  const name = String(projectId || "").trim();
  if (!name) return FALLBACK_LOGO;
  const normalized = name.replace(/\s+/g, "_");
  return `/assets/${normalized}_logo.png`;
}

export default function AppHeader({ title = "Unified Offer & Tracking Form", projectId }) {
  const { logout } = useAuth();
  const logo = logoForProject(projectId);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #ddd",
        padding: "12px 16px",
        background: "white",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <h2 style={{ margin: 0 }}>{title}</h2>
        <img
          src={logo}
          alt={`${projectId || "HBFA"} logo`}
          style={{ height: 44 }}
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = FALLBACK_LOGO;
          }}
        />
      </div>
      <button
        onClick={() => logout?.()}
        style={{
          background: "#dc2626",
          color: "white",
          padding: "6px 12px",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
        }}
      >
        Logout
      </button>
    </div>
  );
}
